import type { FormikErrors } from 'formik'
import { AddNoteFormModel } from '@user/components/Notes/AddNoteDrawer/typings'

export function validateNote(model: AddNoteFormModel) {
  const errors: FormikErrors<AddNoteFormModel> = {}

  const { detail, addNotesToPestPac, serviceLocation, code } = model

  if (!detail || detail?.trim().length === 0) {
    errors.detail = 'Please enter a note'
  }

  if (addNotesToPestPac) {
    if (!serviceLocation) errors.serviceLocation = 'Required'
    if (!code) errors.code = 'Required'
  }

  return errors
}
